import React, { useEffect, useState } from "react";

import { useAuth } from "../../hooks/useAuth";
import { getCoinBaseData, getTransactionsByUserId } from "../../helpers/api";
import { formatDataForGrid } from "../../helpers/formatOpenPostions";

import "./Dashboard.css";

import OpenPositions from "../../components/postions/OpenPositions";
import PortfolioMetrics from "../../components/portfolioMetrics/PortfolioMetrics";
import Spinner from "../../components/loadingAnimations/Spinner";
import DashboardLayout from "../../components/DashboardLayout/DashboardLayout";


const Dashboard = () => {

  const { user } = useAuth();

  const [openPositionData, setOpenPositionData] = useState(null);

  const fetchDataForTables = async () => {
    // this will call both API calls at once and await a return of the promise befor proceeding into the .then
    return Promise.all([
      getTransactionsByUserId(user.userId),
      getCoinBaseData(),
    ]).then(([transactionData, coinbaseData]) => {
      // Deconstructing the reutrn array from .all into the data that is returned from the functions.
      setOpenPositionData(formatDataForGrid(transactionData, coinbaseData));
    });
  };

  useEffect(() => {
    if (user) {
      // console.log("calling use effect")
      fetchDataForTables().then();
    }
  }, [user]);

  return (
    <DashboardLayout page={"Dashboard"}>
      <div className="dashboard-content">
        {/* <Header /> */}
        <PortfolioMetrics openPositionData={openPositionData} />
        {/* <div className="green-box">
          test Div
        </div> */}
        {openPositionData ? (
          <OpenPositions openPositionData={openPositionData} />
        ) : (
          <Spinner containerClass={"spinner-table-container"} />
        )}
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;
